@if (suppliedGridQueryData) {
  <div class="container-fluid d-flex flex-column h-100 g-0 p-0">
    <!-- VPDW-3111: the "Invite vendor" button that used to live here
         has moved to the parent <app-client-vendors> page header. The
         parent calls back into this component via @ViewChild. -->
    <div class="row flex-grow-1 g-0">
      <div class="col-12 pt-3">
        <app-vendors-grid
          [gridName]="'VIVEVendors'"
          [suppliedQueryData]="suppliedGridQueryData"
          [ColumnIdToColumnActions]="ColumnIdToColumnActions"
          [suppressFieldDotNotation]="false"
          [getCalculatedColumnActions]="getCalculatedColumnActions"
          [TooltipMap]="TooltipMap"
          (dataGridQueryChanged)="dataGridQueryChanged.emit($event)"
          (actionEvent)="action($event)"
          (resetAllResultFilters)="onResetFilters($event)"
        ></app-vendors-grid>
      </div>
    </div>
  </div>
}
